import { useBoundStore } from 'useStore';
import { Stack } from '@mui/material';
import FilterChip from './utils/FilterChip';

export default function OwnerFiltersChip() {
	const selectedOwners = useBoundStore(
		(state) => state.productMasterStSelectedOwners
	);
	const clearSelectedOwners = useBoundStore(
		(state) => state.clearProductMasterStSelectedOwners
	);

	if (selectedOwners.length === 0) return null;

	return (
		<Stack direction="row" flexWrap="wrap" gap={1}>
			<FilterChip
				filterName="Owner"
				title={selectedOwners}
				onDelete={() => clearSelectedOwners()}
			/>
		</Stack>
	);
}
